import { BaseRepositoryInterface } from "./base.repository.d";
import { ApiRequest } from "../../modules/ApiRequest/ApiRequest";
import { AxiosRequestConfig } from "axios";
import { ApiRequestConfig } from "../../modules/ApiRequest/ApiRequest.d";

export class BaseRepository<T> implements BaseRepositoryInterface {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  apiRequest: ApiRequest<T>;

  constructor(
    requestConfig: AxiosRequestConfig,
    extendConfig: ApiRequestConfig,
  ) {
    this.apiRequest = new ApiRequest(requestConfig, extendConfig);
  }
}
